export default __webpack_public_path__ + "static/media/Info-icon.03ccdf4f.svg";